<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2026. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: right-bar.vue
  - Created by: chan.ying
  - Create Date: 2026-04-27 15:52
  - Version Number: 1.0
  - Version Description:
  -
  - =============================================================================
  -->

<script>
import {layoutMethods, layoutComputed} from "@/state/helpers";
import DeleteIcon from "@/assets/icons/ruleset/delete-icon.vue";
import ZtnRadio from "@/components/input/ztn-radio.vue";
import ProfileData from "@/utils/cookie/ProfileData";
import ZtnDrawer from "@/components/table-drawer/ztn-drawer.vue";
import ZtnDrawerItem from "@/components/table-drawer/ztn-drawer-item.vue";

/**
 * Right sidebar component
 */
export default {
  components: {ZtnDrawerItem, ZtnDrawer, ZtnRadio, DeleteIcon},
  data() {
    return {
      visible: false,
      themes: [
        {
          label: 'OS',
          value: 'os',
        },
        {
          label: 'Light',
          value: 'light',
        },
        {
          label: 'Dark',
          value: 'dark',
        }
      ],
    };
  },
  methods: {
    ...layoutMethods,
    middleware(event) {
      if (event.target.classList)
        return !event.target.classList.contains("toggle-right");
    },
  },
  computed: {
    ...layoutComputed,
    layout: {
      get() {
        return this.$store ? this.$store.state.layout.layoutType : {} || {};
      },
      set(layout) {
        return this.changeLayoutType({
          layoutType: layout,
        });
      },
    },
    topbar: {
      get() {
        return this.$store ? this.$store.state.layout.topbar : {} || {};
      },
      set(topbar) {
        return this.changeTopbar({
          topbar: topbar,
        });
      },
    },
    sidebarType: {
      get() {
        return this.$store ? this.$store.state.layout.leftSidebarType : {} || {};
      },
      set(type) {
        return this.changeLeftSidebarType({
          leftSidebarType: type,
        });
      },
    },
    loader: {
      get() {
        return this.$store ? this.$store.state.layout.loader : {} || {};
      },
      set(value) {
        return this.changeLoaderValue({
          loader: value,
        });
      },
    }, // end loader
    theme: {
      get() {
        return this.$store ? this.$store.state.layout.theme : 1;
      },
      set(theme) {
        /*if (theme === "light") {
          document.body.classList.remove("dark");
          document.body.classList.add(theme);
          // this.$parent.$refs.sideBar.menu.theme = theme;
        } else if (theme === "dark") {
          document.body.classList.remove("light");
          document.body.classList.add(theme);
          // this.$parent.$refs.sideBar.menu.theme = theme;
        } else {
          document.body.classList.remove("dark");
          document.body.classList.remove("light");
          document.body.classList.add(window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
        }*/
        ProfileData.setAppearance(theme);
        /*return this.changeTheme({
          theme: theme,
        });*/
      },
    }, // end theme
  },
};
</script>

<template>
  <ztn-drawer v-model="visible">
    <ztn-drawer-item>
      <div class="px-3 py-4 d-flex">
        <div class="ztn-page-h2400">Settings</div>
        <div class="right-bar-toggle ms-auto">
          <delete-icon size="24" @click="close"/>
        </div>
      </div>
    </ztn-drawer-item>
    <ztn-drawer-item>
      <div class="p-3">
        <h6 class="ztn-page-h600">Theme</h6>
        <hr class="mt-1"/>
        <ztn-radio :options="themes" v-model:value="theme" :gap="10"/>
      </div>
    </ztn-drawer-item>
  </ztn-drawer>
</template>